import React, { useEffect, useState } from 'react';
import '../CommonStyle.css';
import { GlobalContext } from '../../../store/Store';
import Checkbox from '@mui/material/Checkbox';
import Temperature from '../../../icons/Temperature.svg?react'
import  ActionType from '../../../store/ActionType';
import { MikeSwitch } from '../SwitchControl';
import ProviderDialog from '../../ProviderDialog';
import ProviderIcon from '../../ProviderIcon';
import { SelectedData } from '../../app/AppWrapper';
import Skeleton from '@mui/material/Skeleton';
import { CardHeader, Card, Tooltip } from '@mui/material';
import { Provider } from '../../../generated/src/models';
import TemporalDataCoverage from '../TemporalDataCoverage';
import { getProvider } from '../../utils';

const ForcingSelection = () => {
  const [globalState, globalDispatch] = React.useContext(GlobalContext);
  const [expanded, setExpanded] = React.useState(false);

  const [provider, setProvider] = useState<Provider | undefined>();
  const openDialog = (value: Provider) => () => {
    setProvider(value);
  };
  const closeDialog = () => setProvider(undefined);

  useEffect(() => {
    if (globalState.data.extractionbuilderdata) {
      globalState.data.extractionbuilderdata.forcings.isExpanded = expanded;
      // Update GlobalState with the overwritten Object
      globalDispatch({
        type: ActionType.SET_DATA_EXTRACTION_BUILDER,
        data: globalState.data.extractionbuilderdata,
      });
    }
  }, [expanded]);

  useEffect(() => {
    setExpanded(false);
  }, [globalState.data.extractionbuilderdata]);

  const updateGlobalCount = (count: number, expanded: boolean) => {
    if (!globalState.data.selected) {
      globalState.data.selected = new SelectedData();
    }
    const _state = globalState.data.selected;   
    if (expanded){
      _state.ExpModelForcings = _state.ExpModelForcings + count
    }
    else{
      _state.ModelForcings = _state.ModelForcings + count
    }
     /* expanded = 
     ? (_state.ExpModelForcings = _state.ExpModelForcings + count)
      : (_state.ModelForcings = _state.ModelForcings + count); */
    globalState.data.selected = _state;
  };

  const updateField = (parentIndex: number, childIndex: number) => e => {
    updateGlobalCount(e.target.checked ? 1 : -1, expanded);
    if (expanded === true) {
      globalState.data.extractionbuilderdata.forcings.forcingsExpanded.forcingsExpandedItems[
        parentIndex
      ].providers[childIndex].selected = e.target.checked;

      globalDispatch({
        type: ActionType.SET_DATA_EXTRACTION_BUILDER,
        data: globalState.data.extractionbuilderdata,
      });
    } else {
      globalState.data.extractionbuilderdata.forcings.forcingsCollapsed.forcingsCollapsedItems[
        parentIndex
      ].providers[childIndex].selected = e.target.checked;

      globalDispatch({
        type: ActionType.SET_DATA_EXTRACTION_BUILDER,
        data: globalState.data.extractionbuilderdata,
      });
    }
  };

  const SkeletonItem: React.FC = () => {
    const skeletonRows = [1, 2, 3, 4, 5, 6, 8, 9, 10, 11];
    return (
      <div style={{ overflow: 'hidden' }}>
        {skeletonRows.map((ind: number) => (
          <Card key={ind}>
            <CardHeader
              avatar={<Skeleton animation="wave" variant="circular" width={32} height={32} />}
              title={
                <Skeleton animation="wave" height={12} width="80%" style={{ marginBottom: 6 }} />
              }
              subheader={
                <Skeleton animation="wave" height={12} width="40%" style={{ marginBottom: 6 }} />
              }></CardHeader>
          </Card>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="panelItemHeader tooltipFix">
        Group selection
        <Tooltip title="Activate / de-activate grouping of Forcing data provider options">
          <MikeSwitch checked={!expanded} onChange={() => setExpanded(!expanded)} />
        </Tooltip>
      </div>

      <div className="scrollableContent">
        {globalState.data && globalState.data.fetchingExtractionBuilderData ? (
          <SkeletonItem />
        ) : globalState.data.extractionbuilderdata && expanded ? (
          globalState.data.extractionbuilderdata.forcings.forcingsExpanded.forcingsExpandedItems.map(
            (item, i) => {
              const Item = (
                <div key={i} className="panelItem itemBorder noPadding contentFlex groupedStyle">
                  <div className="panelItemIcon">
                    <Temperature />
                  </div>
                  <div className="panelItemContent">{item.itemName}</div>
                </div>
              );
              const Provides = item.providers.map((item, j) => (
                <div key={j} className="panelItem itemBorder noPadding">
                  <div className="contentFlex">
                    <Checkbox
                      className="panelCheckbox"
                      checked={item.selected}
                      onChange={updateField(i, j)}
                      value={item.selected}
                      color="secondary"
                      inputProps={{
                        'aria-label': 'secondary checkbox',
                      }}
                    />
                    <div className="panelItemIcon">
                      <ProviderIcon onClick={openDialog(item)} provider={item} />
                    </div>
                    <div>
                      <div className="panelItemContent cursorPointer" onClick={openDialog(item)}>
                        {item.displayName}
                      </div>
                      <TemporalDataCoverage provider={getProvider(globalState, item.name)} />
                    </div>
                  </div>
                </div>
              ));
              return [Item, Provides];
            }
          )
        ) : (
          ''
        )}

        {globalState.data.extractionbuilderdata && !expanded
          ? globalState.data.extractionbuilderdata.forcings.forcingsCollapsed.forcingsCollapsedItems.map(
              (item, i) => {
                return (
                  <React.Fragment key={i}>
                    <div className="panelItemHeader2">Grouped items ({item.items.length})</div>
                    <div className="">
                      {item.items.map((item, i) => (
                        <div key={i} className="panelItem itemBorder noPadding">
                          <div className="panelItemIcon">
                            <Temperature />
                          </div>
                          <div className="contentFlex">{item}</div>
                        </div>
                      ))}
                      {item.providers.map((item, j) => (
                        <div key={j} className="panelItem itemBorder noPadding">
                          <div className="contentFlex">
                            <Checkbox
                              className="panelCheckbox"
                              checked={item.selected}
                              onChange={updateField(i, j)}
                              value={item.selected}
                              color="secondary"
                              inputProps={{
                                'aria-label': 'secondary checkbox',
                              }}
                            />
                            <div className="panelItemIcon">
                              <ProviderIcon onClick={openDialog(item)} provider={item} />
                            </div>
                            <div>
                              <div
                                className="panelItemContent cursorPointer"
                                onClick={openDialog(item)}>
                                {item.displayName}
                              </div>
                              <TemporalDataCoverage
                                provider={getProvider(globalState, item.name)}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </React.Fragment>
                );
              }
            )
          : ''}
      </div>

      <ProviderDialog open={!!provider} provider={provider} onClose={closeDialog} />
    </>
  );
};
export default ForcingSelection;
